import React, { useState } from 'react';

interface CopyLinkProps {
  text: string;
  onCopy?: () => void;
  children: React.ReactNode;
}

const CopyLink: React.FC<CopyLinkProps> = ({ text, onCopy, children }) => {
  const [linkCopied, setLinkCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setLinkCopied(true);
      if (onCopy) {
        onCopy();
      }
    } catch (err) {
      console.error('Failed to copy:', err);
      setLinkCopied(false);
    }
  };

  return (
    <div>
      <div className="link-to-copy" onClick={handleCopy}>
        {children}
      </div>
      {linkCopied ? <span>Link copied!</span> : null}
    </div>
  );
};

export default CopyLink;
